import { z } from "zod";

import { RecommendedProductSchema } from "../../../schemas/ai";

export const GetRecommendedProductsRequestBodySchema = z.object({
  product: z.object({
    productId: z.string(),
    productTitle: z.string(),
  }),
  numResults: z.number(),
});

export type GetRecommendedProductsRequestBodyType = z.infer<
  typeof GetRecommendedProductsRequestBodySchema
>;

export const GetRecommendedProductsResponseBodySchema = z.object({
  products: RecommendedProductSchema.array(),
});

export type GetRecommendedProductsResponseBodyType = z.infer<
  typeof GetRecommendedProductsResponseBodySchema
>;
